var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Create',{attrs:{"id":_vm.$route.params.id,"tid":_vm.$route.params.tid},on:{"created":_vm.redirect}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }